export const removeUndefinedProperties = (obj: any): any => {
  if (Array.isArray(obj)) {
    return obj.map(removeUndefinedProperties);
  } else if (obj && typeof obj === "object") {
    return Object.entries(obj).reduce((acc, [key, value]) => {
      if (value !== undefined && value !== null) {
        acc[key] = removeUndefinedProperties(value);
      }
      return acc;
    }, {} as any);
  }
  return obj;
};
